import $ from 'jquery';
import { getFeatureById } from './aiFeatureCategories';

/**
 * Initialize individual AI feature help buttons
 */
export function initAiIndividualHelp() {
  // Remove existing listeners to prevent duplicates
  $('body').off('click.aiIndividualHelp', '.ai-feature-help-btn');

  // Handle individual help button clicks
  $('body').on('click.aiIndividualHelp', '.ai-feature-help-btn', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const featureId = $(this).data('feature');
    const feature = getFeatureById(featureId);

    if (!feature) {
      console.warn(`Feature not found: ${featureId}`);
      return;
    }

    // Populate modal content
    $('#aiFeatureDetailTitle').text(feature.title);
    $('#aiFeatureDetailDescription').text(feature.description);

    // Update highlight text
    if (feature.highlightText) {
      $('#aiFeatureDetailHighlightText').text(feature.highlightText);
      $('#aiFeatureDetailTagline').show();
    } else {
      $('#aiFeatureDetailTagline').hide();
    }

    // Always show before/after images
    const beforeSrc =
      feature.beforeImg ||
      'https://files.onoranzefunebricloud.com/9QpXpq6aio_allegati_99a6ae8a-4952-4a59-a4bf-14561b8fcb36.png';
    const afterSrc =
      feature.afterImg ||
      'https://files.onoranzefunebricloud.com/9QpXpq6aio_allegati_5ee3841a-a68a-41a9-bab5-f1890d87b8ac.jpeg';

    $('#aiFeatureDetailBeforeImg').attr('src', beforeSrc).show();
    $('#aiFeatureDetailAfterImg').attr('src', afterSrc).show();

    // Set animated comparison images
    $('#animatedBeforeImg').attr('src', beforeSrc);
    $('#animatedAfterImg').attr('src', afterSrc);

    // Features with horizontal before/after images get a stacked layout
    $('#aiFeatureDetailModal .ai-feature-layout').toggleClass(
      'ai-feature-layout--landscape',
      Boolean(feature.landscapeImages)
    );

    // Populate FAQ section
    const $faqContainer = $('#aiFeatureDetailFAQ');
    const $faqSection = $('#aiFeatureDetailFAQSection');
    $faqContainer.empty();

    if (feature.faq && feature.faq.length > 0) {
      // Show FAQ section
      $faqSection.show();

      feature.faq.forEach((faq, index) => {
        const faqItem = $(`
          <div class="faq-item">
            <button class="faq-question" data-faq-index="${index}">
              ${faq.question}
            </button>
            <div class="faq-answer" id="faq-answer-${index}">
              <p>${faq.answer}</p>
            </div>
          </div>
        `);
        $faqContainer.append(faqItem);
      });

      // Handle FAQ accordion functionality
      $('.faq-question')
        .off('click')
        .on('click', function () {
          const $this = $(this);
          const $answer = $this.next('.faq-answer');

          // Toggle current answer
          $this.toggleClass('active');
          $answer.toggleClass('show');

          // Close other answers
          $('.faq-question').not($this).removeClass('active');
          $('.faq-answer').not($answer).removeClass('show');
        });
    } else {
      // Hide FAQ section if no FAQs
      $faqSection.hide();
    }

    // Show modal
    $('#aiFeatureDetailModal').modal('show');

    // Prevent ESC key from propagating to global handlers
    $('#aiFeatureDetailModal').on('keydown.aiModal', function (e) {
      if (e.keyCode === 27) {
        e.stopPropagation();
      }
    });

    // Clean up event handler when modal is hidden
    $('#aiFeatureDetailModal').on('hidden.bs.modal.aiModal', function () {
      $(this).off('keydown.aiModal');
      $(this).off('hidden.bs.modal.aiModal');
    });

    // Ensure buy credits button works in modal
    $('#aiFeatureDetailModal [data-sidebar-action="buy-ai-credits"]')
      .off('click.modalBuyCredits')
      .on('click.modalBuyCredits', async function (e) {
        e.preventDefault();
        $('#aiFeatureDetailModal').modal('hide');
        const { handleBuyAiCredits } = await import(
          '../../sidebar/handleBuyAiCredits'
        );
        await handleBuyAiCredits();
      });
  });
}
